import { defineMessages } from "react-intl";

export const factorMessages = defineMessages({
  factorListTitle: {
    id: "factorListTitle",
    defaultMessage: "Two-Factor Authentication",
  },
  factorListSwitcher: {
    id: "factorListSwitcher",
    defaultMessage: "Turn on two - factor authentication",
  },
  factorListDescription: {
    id: "factorListDescription",
    defaultMessage:
      "If you turn on two - factor authentication, each time you log in you'll verify your identify with:",
  },
  factorListFirstSetupDescription: {
    id: "factorListFirstSetupDescription",
    defaultMessage:
      "You’ll sign in with your password and a code sent to your email or phone. Email is always enabled, and you can choose one additional option.",
  },
  factorListTokenizedDescription: {
    id: "factorListTokenizedDescription",
    defaultMessage:
      "If you enable two-factor authentication, you’ll sign in with your password and a code sent to your email or phone. Email is always enabled, and you can choose one additional option.",
  },
  factorListSetUp: {
    id: "factorListSetUp",
    defaultMessage: "Set Up",
  },
  factorListNext: {
    id: "factorListNext",
    defaultMessage: "Next",
  },
  factorListSave: {
    id: "factorListSave",
    defaultMessage: "Save",
  },
  factorListUpdate: {
    id: "factorListUpdate",
    defaultMessage: "Update",
  },
  factorListCancel: {
    id: "factorListCancel",
    defaultMessage: "Cancel",
  },
  factorListSkip: {
    id: "factorListSkip",
    defaultMessage: "Skip",
  },
  factorListPassword: {
    id: "factorListPassword",
    defaultMessage: "Your password",
  },
  factorListCodeSent: {
    id: "factorListCodeSent",
    defaultMessage: "A code sent to a device, like your phone",
  },
  factorListIncorrectActivationCode: {
    id: "factorListIncorrectActivationCode",
    defaultMessage: "Incorrect code.",
  },
  factorListInfo: {
    id: "factorListInfo",
    defaultMessage: "Email is required",
  },
  factorListInfoMessage: {
    id: "factorListInfoMessage",
    defaultMessage: "You will receive the security code via email.",
  },
  factorListSelectAdditionalMethod: {
    id: "factorListSelectAdditionalMethod",
    defaultMessage: "Select an additional method (optional)",
  },
  factorListUpdateContactDetails: {
    id: "factorListUpdateContactDetails",
    defaultMessage: "Update contact details",
  },
});
